"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var uuid_1 = require("uuid");
var Contexts_1 = require("../Contexts");
var ViewParentContext = react_1.default.createContext(undefined);
var ViewComponent = /** @class */ (function (_super) {
    __extends(ViewComponent, _super);
    function ViewComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.uid = uuid_1.v4();
        _this.mountState = "premounted";
        return _this;
    }
    ViewComponent.prototype.componentDidMount = function () {
        this.mountState = "mounted";
        this.forceUpdate();
    };
    ViewComponent.prototype.componentWillUnmount = function () {
        this.mountState = "unmounted";
        this.context.deleteRunningView(this.uid);
    };
    ViewComponent.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement(Contexts_1.AppContext.Consumer, null, function (app) {
            if (!app || _this.mountState !== "mounted") {
                return react_1.default.createElement(react_1.default.Fragment, null, " ");
            }
            return (react_1.default.createElement(ViewParentContext.Consumer, null, function (parent) {
                app.updateRunningView({
                    parentUid: (parent === null || parent === void 0 ? void 0 : parent.uid) || "",
                    isRoot: parent === undefined,
                    childIndex: (parent === null || parent === void 0 ? void 0 : parent.childIndex) || 0,
                    name: _this.props.name,
                    props: _this.props.props,
                    uid: _this.uid,
                });
                if (Array.isArray(_this.props.children)) {
                    return _this.props.props.children.map(function (child, index) { return (react_1.default.createElement(ViewParentContext.Provider, { key: index, value: { uid: _this.uid, childIndex: index } }, child)); });
                }
                else {
                    return (react_1.default.createElement(ViewParentContext.Provider, { value: { uid: _this.uid, childIndex: 0 } }, _this.props.props.children));
                }
            }));
        }));
    };
    ViewComponent.contextType = Contexts_1.AppContext;
    return ViewComponent;
}(react_1.default.Component));
exports.default = ViewComponent;
